import {TranslateService} from '@ngx-translate/core';

import {DashboardChartUtils} from './dashboard-chart.utils';

import {ChartUtils} from '../../+postpayroll/check/key-metrics/charts/chart.utils';
import {StackedBar} from '../../+postpayroll/check/key-metrics/charts/column/stacked-bar';
import {Chart} from '../../+postpayroll/check/key-metrics/key-metrics.interfaces';
import {LocalizationService} from '../../shared/localization/localization.service';
import {Scss} from '../../shared/utils/scss';
import {ChartBoxElement, DashboardBox, ResponseChartBox} from '../dashboard.interfaces';

export class ContractsToCheckChart extends StackedBar {

  constructor(chartBox: ResponseChartBox, translate: TranslateService, localization: LocalizationService) {
    const params = chartBox.params;
    const chart: Chart = ChartUtils.getEmptyChart();
    let total: number = 0;

    Object.keys(params).forEach((key: string) => {
      if (!params[key].length) {
        chart.data.push({
          category: null,
          name: key,
          value: null
        });
      }

      params[key].forEach((element: ChartBoxElement) => {
        total += element.value;
        chart.data.push({
          category: element.name,
          name: key,
          value: element.value,
          metadata: element.link
        });
      });
    });
    chart.type = chartBox.cardType;

    super(chart, translate, localization, total);

    this.legend = {
      orient: 'horizontal',
      top: 0
    };

    this.xAxis = [
      {
        type: 'value',
        axisLabel: {
          formatter: (value) => this.localization.localizeNumber(value, 'INTEGER')
        },
        axisLine: {
          show: true
        },
        axisTick: {
          show: true,
          alignWithLabel: true,
        }
      }
    ];
    this.yAxis = [{
      axisLabel: DashboardChartUtils.getAxisOptions(),
      data: this.yAxis.data.map((value: string) => translate.instant(value)),
      axisTick: {
        show: true,
      }
    }];

    this.grid = DashboardChartUtils.getGridOptions();
    this.animation = true;
    this.tooltip.position = DashboardChartUtils.getTooltipPositionFunc(<DashboardBox>chartBox);
    DashboardChartUtils.setLinks(this.series, this.chart, this.categories);
    this.color = DashboardChartUtils.standardColors();

    const colors = {
      'Inactive': Scss.variable('contract-inactive'),
      'Active': Scss.variable('contract-active'),
      'Future': Scss.variable('contract-future'),
    };

    this.series.forEach((serie, index) => {
      const barColor = colors[serie.name] || this.color[index];
      serie.itemStyle = {
        normal: {
          color: barColor,
          barBorderRadius: 5,
          barBorderWidth: 1,
          label: {
            show: true,
            formatter: this.getLabelFormatter(),
            textStyle: {
              color: DashboardChartUtils.textColor(barColor)
            }
          }
        }
      };
    });
  }

  public getLabelFormatter(): (value) => string {
    return (value) => {
      return value.value ?
        this.localization.localizeNumber(value.value, 'INTEGER') :
        '';
    };
  }

  public sortCategories(array: string[]): string[] {
    return ['CONTRACTS_TO_CHECK.alerts', 'CONTRACTS_TO_CHECK.events', 'CONTRACTS_TO_CHECK.incomplete', 'CONTRACTS_TO_CHECK.all'];
  }
}
